import { makeObservable, observable, action } from 'mobx';

var UserCountStore = /** @class */ (function () {
    function UserCountStore() {
        this.usersCount = 0;
        makeObservable(this, {
            usersCount: observable,
            setUsersCount: action.bound,
        });
    }
    UserCountStore.prototype.setUsersCount = function (code) {
        this.usersCount = code;
    };
    return UserCountStore;
}());
var userCountStore = new UserCountStore();

export { UserCountStore, userCountStore };
